module.exports = __webpack_public_path__ + "img/shipinhao.81f9b494.png";